/* eslint-disable spire/export-styles */
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface ProductPriceCodeStyles {
    wrapper?: any;
    priceCodeLabel?: TypographyPresentationProps;
    priceCodeMessage?: TypographyPresentationProps;
    priceCodeMessageWrapper?: InjectableCss;
}

export const productPriceStyles: ProductPriceCodeStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            align-items: center;
            margin-bottom: 20px;
        `,
    },
    priceCodeLabel: {
        css: css`
            color: rgb(230, 78, 37);
            font-weight: 600;
        `,
    },
    priceCodeMessage: {
        css: css`
            color: rgb(230, 78, 37);
        `,
    },
    priceCodeMessageWrapper: {
        css: css`
            ${wrapInContainerStyles}
        `,
    },
};

const SectionWrapper = getStyledWrapper("section");

const ProductPriceCode: React.FC<HasProduct> = ({ product }) => {
    if (!product) {
        return null;
    }

    return (
        <div>
            {product.detail?.priceCode && (
                <StyledWrapper {...productPriceStyles.wrapper}>
                    <Typography {...productPriceStyles.priceCodeLabel}>{translate("Free_Offer")}&nbsp;</Typography>
                    <Typography {...productPriceStyles.priceCodeMessage}>
                        {translate(`ProductDetail_${product.detail?.priceCode}`)}
                    </Typography>
                </StyledWrapper>
            )}
        </div>
    );
};

const productPriceCodeModule: WidgetModule = {
    component: withProduct(ProductPriceCode),
    definition: {
        group: "Products",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default productPriceCodeModule;
